import { ReactNode } from 'react';
import { StyleSheet, Text, TextInput, TextInputProps, View } from 'react-native';

export interface InputProps extends TextInputProps {
  label?: string;
  error?: string;
  rightElement?: ReactNode;
  colors: {
    card: string;
    border: string;
    text: string;
    textSecondary: string;
    textTertiary: string;
    error: string;
  };
}

export const Input = ({ label, error, rightElement, colors, style, ...props }: InputProps) => {
  return (
    <View style={styles.container}>
      {label && <Text style={[styles.label, { color: colors.textSecondary }]}>{label}</Text>}
      <View style={styles.inputWrapper}>
        <TextInput
          style={[
            styles.input,
            {
              backgroundColor: colors.card,
              borderColor: error ? colors.error : colors.border,
              color: colors.text,
            },
            rightElement ? styles.inputWithRight : null,
            style,
          ]}
          placeholderTextColor={colors.textTertiary}
          {...props}
        />
        {rightElement && (
          <View style={styles.rightElement}>{rightElement}</View>
        )}
      </View>
      {error && <Text style={[styles.error, { color: colors.error }]}>{error}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 15,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 8,
  },
  inputWrapper: {
    position: 'relative',
  },
  input: {
    borderWidth: 1,
    borderRadius: 10,
    padding: 15,
    fontSize: 16,
  },
  inputWithRight: {
    paddingRight: 48,
  },
  rightElement: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    paddingHorizontal: 14,
  },
  error: {
    fontSize: 12,
    marginTop: 5,
  },
});
